import { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const GLBModel = ({ url }) => {
  const ref = useRef();

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, 300 / 300, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(300, 300);
    if (ref.current) ref.current.appendChild(renderer.domElement);

    const loader = new GLTFLoader();
    loader.load(
      url,
      (gltf) => {
        scene.add(gltf.scene);
      },
      undefined,
      (error) => {
        console.error('Error loading GLB:', error);
      }
    );

    // Añadir luz para que el modelo sea visible
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
    directionalLight.position.set(0, 1, 0).normalize();
    scene.add(directionalLight);

    camera.position.z = 5;

    // Añadir OrbitControls
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableZoom = true; // Habilitar zoom
    controls.enablePan = true; // Habilitar movimiento
    controls.enableRotate = true; // Habilitar rotación
    controls.update();

    const animate = () => {
      requestAnimationFrame(animate);
      controls.update(); // Actualizar controles en cada frame
      renderer.render(scene, camera);
    };
    animate();

    return () => {
      if (ref.current && renderer.domElement) {
        ref.current.removeChild(renderer.domElement);
      }
    };
  }, [url]);

  return <div ref={ref} style={{ width: '300px', height: '300px', margin: '0 auto' }} />;
};

export default GLBModel;
